import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { NoticeService } from '@millionshow/api-client';
import { Icon, SafeHtmlPipe } from '@millionshow/client-libs';
import FileDownloadComponent from 'packages/client-libs/src/components/file-download/file-download.component';
import { injectParams } from 'ngxtension/inject-params';
import { of } from 'rxjs';
import { SeoService } from '../../../../services/seo.service';

@Component({
  selector: 'app-notice-detail',
  imports: [
    CommonModule,
    RouterLink,
    Icon,
    SafeHtmlPipe,
    FileDownloadComponent,
  ],
  templateUrl: './notice-detail.page.html',
})
export default class NoticeDetailPage {
  private readonly noticeService = inject<NoticeService>(NoticeService);
  private readonly seoService = inject(SeoService);

  readonly id = injectParams('id');

  constructor() {
    effect(() => {
      const data = this.data();

      if (!data) return;

      this.seoService.set({
        title: data.title || '공지사항 상세',
        description:
          this.stripHtml(data.content || '').slice(0, 140) ||
          '밀리언쇼 공지사항 상세 내용을 확인해보세요.',
        path: `/customer/notice/${this.id()}`,
      });
    });
  }

  $data = rxResource({
    params: () => ({ id: this.id() }),
    stream: ({ params }) =>
      params.id
        ? this.noticeService.noticeControllerFindByIdV1({ id: params.id })
        : of(null),
  });

  readonly data = computed(() => this.$data.value());
  files = computed(() => this.data()?.files ?? []);

  $adjacentNotices = rxResource({
    params: () => ({ id: this.id() }),
    stream: ({ params }) =>
      params.id
        ? this.noticeService.noticeControllerFindAdjacentV1({
            id: params.id,
          })
        : of(null),
  });

  prevNotice = computed(() => this.$adjacentNotices.value()?.prev ?? null);
  nextNotice = computed(() => this.$adjacentNotices.value()?.next ?? null);

  stripHtml(html: string): string {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, '');
  }
}
